import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Pencil } from 'lucide-react';

interface QuotationHeaderProps {
  name: string;
  bankName?: string;
  bankAlias?: string;
  createdAt: string;
  onEdit: () => void;
}

export function QuotationHeader({ name, bankName, bankAlias, createdAt, onEdit }: QuotationHeaderProps) {
  return (
    <>
      <Link to="/quotations" className="back-link">
        <ArrowLeft className="w-4 h-4" />
        Back to Quotations
      </Link>

      <div className="page-header">
        <div>
          <h1 className="page-title">{name}</h1>
          <p className="page-subtitle">
            {bankName && bankAlias ? `${bankName} (${bankAlias}) · ` : ''}
            Created {new Date(createdAt).toLocaleDateString()}
          </p>
        </div>
        <button onClick={onEdit} className="btn-secondary">
          <Pencil className="w-4 h-4" />
          Edit Quotation
        </button>
      </div>
    </>
  );
}
